var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},[_c('section',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"loading-animation"}},[_c('i',{staticClass:"el-icon-loading",staticStyle:{"font-size":"2rem","color":"white"}})])])])
}]

export { render, staticRenderFns }